import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
  public title = 'Delete';
  public text = 'Are you sure you want to delete this item?';
  public confirm = 'Confirm';
  public cancel = 'Cancel';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title || this.title;
      this.text = this.data.text || this.text;
      this.cancel = this.data.cancel || this.cancel;
      this.confirm = this.data.confirm || this.confirm;
    }
  }

  onYesClick(): void {
    this.dialogRef.close('ok');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}


